module.exports = __webpack_public_path__ + "img/icon_c.4ffd38ef.png";